import React, { memo, ReactElement } from 'react';
import withLoading from 'adapter/in/common/hoc/withLoading';
import { StyledOptionsForm } from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration/Tabs/OptionForm/style';

export type OptionsFormType = {
    data: ReactElement[];
};

const OptionsForm = memo(
    (props: OptionsFormType): ReactElement => {
        const { data: options } = props;
        return <StyledOptionsForm data-testid='options-form'>{options}</StyledOptionsForm>;
    }
);

export default withLoading(OptionsForm);
